document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.querySelector('.quiz-confirm-link');
  closeBtn.addEventListener('click', () => {
    const slides = document.querySelectorAll('.quiz-slide');
    let pageIndex = -1;

    slides.forEach((slide, i) => {
      if (slide.getAttribute('aria-current') === 'true') {
        pageIndex = i + 1;
      }
    });
    dataLayer.push({
      event: 'custom_event',
      event_name: 'quiz_close',
      parameter: JSON.stringify({
        page_number: `${pageIndex}`
      })
    });
  });
  const quizSlidesSubmitBtn = document.querySelectorAll('.quiz-next');
  quizSlidesSubmitBtn.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      const quizSlide = btn.closest('.quiz-slide');
      const quizForm = quizSlide.querySelector('.quiz-form');
      const answer = quizForm.querySelector('.quiz-option.selected');
      const answerIndex = answer?.dataset.index;
      dataLayer.push({
        event: 'custom_event',
        event_name: 'quiz_answer_submit',
        parameter: JSON.stringify({
          page_number: `${index + 1}`,
          answer_number: `${answerIndex}`
        })
      });
    });
  });
});
